import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { ConfigService } from '../config/config.service';
import { AppTokenService, BasePermissionsService } from '@synx-cloud/services';
interface JWTToken {role, emails, email, sub, group, tenant_id, tenant_name}

@Injectable({
  providedIn: 'root'
})
export class PermissionsService extends BasePermissionsService {

  private roles: string[];
  private email: string = null;
  private sub: string = null;
  private group: string = null;
  private tenantid: string = null;
  private tenantname: string = null;

  // Getters
  get roleList() {
      return this.roles;
  }

  get username() {
      return this.email;
  }

  /**
   * Whether the signed-in user is Synectics-internal (an @synx.com login). Mirrors the server's
   * UserUtils.IsSynecticsEmail, which is the security boundary; this is for gating the UI.
   */
  get isSynxInternal() {
      return !!this.email && this.email.toLowerCase().endsWith("@synx.com");
  }

  get userId() {
      return this.sub;
  }

  get userGroup() {
      return this.group;
  }

  get TenantName() {
      return this.tenantname;
  }
  get TenantId() {
      return this.tenantid;
  }

  constructor(private oauthService: OAuthService,
              private configService: ConfigService,
              private appTokenService: AppTokenService)
  {
      super();
      if (this.roles == null)
      {
          if (localStorage.access_token != null)
          {
              this.setRolesFromToken();
          }
      }
  }

  setRolesFromToken(): void {
      let tokenPayload: JWTToken;
      if (this.configService.appTokenMode)
      {
          // In app-token mode the B2C token is no longer enriched with extension_* claims;
          // read them from the minted app token instead. Bail (don't fall back to the
          // un-enriched B2C token, which would yield undefined roles) if it hasn't been
          // minted yet — bootstrap re-runs this after a successful mint.
          const appClaims = <JWTToken>this.appTokenService.getClaims();
          if (appClaims == null)
          {
              return;
          }
          tokenPayload = appClaims;
      }
      else
      {
          tokenPayload = <JWTToken>this.oauthService.getIdentityClaims();
      }

      this.roles = [tokenPayload['extension_Role']];
      this.tenantid = tokenPayload['extension_tenant_id'];
      this.tenantname = tokenPayload['extension_tenant_name'];
      this.sub = tokenPayload['sub'];
      console.log("multi-tenant:"+JSON.stringify(this.roles)+" tenantid:"+this.tenantid+" "+ this.tenantname+" userid:"+this.sub);
      if(tokenPayload.emails!=null && tokenPayload.emails.length>0)
      {
          this.email = tokenPayload.emails[0];
      }
      if(this.email==null)
      {
          this.email = tokenPayload.email;
      }
  }
    roleCheck(roleList: string[]): boolean
    {
        if(this.roles==null)
        {
            this.setRolesFromToken();
        }


        if (this.roles == null)
        {
            return;
        }
        return this.roles.some(role => roleList.includes(role));
    }
}
